/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {colors} from "nxtconstants";

const FeaturesBar = ({
  featuresList
}) => {
  return (
    <FeaturesWrapper>
      <FeaturesList>
        {
          featuresList.map((item, index) => (
            <FeatureItem key={index}>
              <FeatureIcon
                alt={item.context}
                src={item.icon}
              />
              <FeatureContext>
                {item.context}
              </FeatureContext>
            </FeatureItem>
          ))
        }
      </FeaturesList>
    </FeaturesWrapper>
  );
};

const FeaturesWrapper = styled.div`
  margin-top: auto;
  padding: 0 3rem 5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const FeaturesList = styled.div`
  display: flex;
  gap: 2.2rem;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
`;

const FeatureIcon = styled.img`
  flex-shrink: 0;
  width: 30px;
  margin-right: 1.2rem;
`;

const FeatureContext = styled.div`
  font-size: 1.2rem;
  color: ${colors.textGray};
  line-height: 1.4;
`;

export default FeaturesBar;
